import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
  nullSafeOptionalString,
  nullSafeString,
  nullSafeStringArray,
} from '../shared/schema'
import { SlideQuestionType } from '../../models/SlideQuestionType'
import { PopUpIcon } from '../../types/firestore'
import { VoiceOption } from '../../models/VoiceOption'

const slideQuestionTypeSchema = z.nativeEnum(SlideQuestionType)

const popUpIconSchema = z.nativeEnum(PopUpIcon)

// dart definition
// required List<String> answers, default: []
// required String question, default: ''
// required SlideQuestionType questionType, default: SlideQuestionType.poll
// int? correct,
// String? groupSlideId,
// String? slideId,
// int? updatedAt,
export const schema = z.object({
  answers: nullSafeStringArray([]),
  question: nullSafeString(''),
  order: nullSafeOptionalNumber(),
  questionType: z.preprocess(
    (val) => val ?? SlideQuestionType.poll,
    slideQuestionTypeSchema
  ),
  correct: nullSafeOptionalNumber(),
  groupSlideId: nullSafeOptionalString().nullable(),
  slideId: nullSafeOptionalString().nullable(),
  explanation: nullSafeOptionalString().nullable(),
  prompt: nullSafeOptionalString().nullable(),
  promptTypeId: nullSafeOptionalString().nullable(),

  updatedAt: nullSafeOptionalFirestoreTimestamp(),

  popUpIcon: popUpIconSchema.nullish(),
  popUpTitle: nullSafeOptionalString().nullish(),
  popUpInstructions: nullSafeOptionalString().nullish(),
  popUpButtonLabel: nullSafeOptionalString().nullish(),

  maxListLength: z.coerce.number().optional(),
  minListLength: z.coerce.number().optional(),

  schema: nullSafeOptionalString(),

  /** solo bot types only */
  showPreviousBotSlideTranscripts: nullSafeOptionalBoolean(),

  /** solo bot types only */
  showPreviousSlideTranscripts: nullSafeOptionalBoolean(),

  /** solo bot types only */
  showCurrentSlideTranscripts: nullSafeOptionalBoolean(),

  voiceId: z
    .nativeEnum(VoiceOption)
    .nullish()
    .transform((val) => (val ? val : undefined)),
})

export const empty = Object.freeze(
  schema.parse({
    answers: [],
    question: '',
    questionType: SlideQuestionType.poll,
  })
)

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export interface FirestoreSlideQuestion extends z.infer<typeof schema> {}
